<template>
    <modal-centered-base
    :title="t('uploader.deleteModal.title')"
    :titleIcon="'warning'"
    negative
    :leftButtonText="t('uploader.no')"
    :rightButtonText="t('uploader.deleteModal.deleteButton')"
    :rightButtonIcon="'check-line'"
    :triggerClose="triggerClose"
    @hideMe="emit('hideMe')"
    @clicked="emit('hideMe')"
    @rightButtonClicked="emit('rightButtonClicked')">
        <span>{{t('uploader.deleteModal.message')}}</span>
    </modal-centered-base>
</template>

<script setup>
import ModalCenteredBase from '@/components/generic/modals/centered/Base'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'rightButtonClicked'])

</script>

<style lang="scss" scoped>
span {
    @include H6-Regular;
    color: var(--secondary-dark-2);
    line-height: 18px;
}
</style>
